<template>
  <div class="notification-card-container">
    <div class="notification-details">
      <BbIcon class="notification-icon" :name="notification.iconName" :type="notification.iconType || 'outlined'" />
      <div class="notification-description">
        <TextBody tag="span" :text="notification.description" :body-type="3" />
        <div class="notification-actions-container">
          <BbBtn v-if="notification.action" class="action-button" size="small" color="#6222e3" @click="onAction">
            <TextBody v-if="!isActionLoading" :text="notification.actionName" />
            <BbIcon v-else name="spin" />
          </BbBtn>
          <BbBtn
            v-if="notification.secondAction"
            class="action-button"
            size="small"
            color="#6222e3"
            @click="onSecondAction"
          >
            <TextBody :text="notification.secondActionName" />
          </BbBtn>
        </div>
      </div>
    </div>
    <span class="created-at">{{ formattedCreatedAt }}</span>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import TextBody from '~/components/common/TextBody';
import { calculatePassedTime } from '~/utils/date-utils';

export default {
  components: { TextBody },
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const isActionLoading = ref(false);

    const onAction = async () => {
      isActionLoading.value = true;
      await props.notification.action();
      isActionLoading.value = false;
    };

    const onSecondAction = async () => {
      isActionLoading.value = true;
      await props.notification.secondAction();
      isActionLoading.value = false;
    };
    const formattedCreatedAt = computed(() => calculatePassedTime(props.notification.createdAt));

    return {
      formattedCreatedAt,
      isActionLoading,
      onAction,
      onSecondAction,
    };
  },
};
</script>

<style scoped lang="scss">
.notification-card-container {
  display: flex;
  padding: $bb-spacing-3;
  align-items: flex-start;
  gap: $bb-spacing-2;
  width: 100%;
  background: $bb-neutral-0;
  border-radius: 8px;

  .notification-details {
    display: flex;
    align-items: flex-start;
    gap: 8px;

    .notification-description {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .notification-actions-container {
      display: flex;
      gap: 8px;
    }

    .icon-approved-filled {
      display: flex;
      width: 24px;
      height: 24px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      color: #33beff;
    }

    .icon-information-filled {
      display: flex;
      width: 24px;
      height: 24px;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      color: $bb-interface-5;
    }
  }

  .created-at {
    @include bb-medium-text-styles('xs');
    color: $bb-neutral-3;
    margin-left: auto;
  }
}
</style>
